import * as React from "react";
import styled from "styled-components";

import Translate from "../../common/components/Translate";

type Post = WtdModels.Partial<WtdModels.Post, "post_path">;

export interface MembershipCardStoryModels {
  Post: Post;
}

interface Props {
  post: Post;
}

interface State {
  isHovered: boolean;
  isTouched: boolean;
}

class MembershipCardStory extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isHovered: false,
      isTouched: false,
    };
  }

  public onToushStart = () => {
    this.setState({
      isTouched: true,
    });
  };

  public onMouseEnter = () => {
    this.setState({
      isHovered: true,
    });
  };

  public onMouseLeave = () => {
    this.setState({
      isHovered: false,
    });
  };

  public render() {
    const { post } = this.props;
    const { isHovered, isTouched } = this.state;
    const hover = isHovered && !isTouched;
    return (
      <StoryButton
        href={post.post_path}
        hover={hover}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onTouchStart={this.onToushStart}
      >
        {hover ? (
          <HeadLine>
            <Translate id="company.members.story" />
          </HeadLine>
        ) : (
          <Icon className="icon icon-microphone" />
        )}
      </StoryButton>
    );
  }
}

const StoryButton = styled.a`
  display: block;
  background-color: rgba(0, 164, 187, 1);
  border-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  transition: all 100ms linear;
  &:hover {
    text-decoration: none;
  }
  width: ${(props: { hover: boolean }) => (props.hover ? "110px" : "30px")};
`;

const HeadLine = styled.span`
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  color: white;
`;

const Icon = styled.i`
  display: block;
  font-size: 14px;
  color: white;
`;

export default MembershipCardStory;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipCardStory.tsx